/**
 * @author      yewon@zumper.com (Yewon Lee)
 * @copyright   Copyright (c) 2019, Zumper
 * @description similarListings constants
 */

export const CLEAR_LISTABLES = '@@nr/similarListings/CLEAR_LISTABLES'
export const DONE_FETCHING = '@@nr/similarListings/DONE_FETCHING'
export const ERROR_FETCHING = '@@nr/similarListings/ERROR_FETCHING'
export const RECEIVE_LISTABLES = '@@nr/similarListings/RECEIVE_LISTABLES'
export const START_FETCHING = '@@nr/similarListings/BEGIN_FETCHING'
